import BaseModule from "./base-module";

class Delivery extends BaseModule {
    getDeliveryCategory(params) {
        return this.get("/v1/commoditycategory", {params});
    }

    getDeliveryCategory2(params) {
        return this.get("/v1/commodity/category", {
            params: {
                ...(params || {}),
                is_takeaway: true
            }
        });
    }

    getDeliveries(params) {
        return this.get("/v1/commodity/all", {params});
    }

    getDeliveryDetail(params) {
        return this.get("/v1/commodity/details", {params});
    }

    getRecommendDelivery(params) {
        return this.get("/v1/commodity/recommend", {params});
    }
}

export default new Delivery();
